import { homePermissionsRequested } from "App";
import Button from "components/ui/Button";
import { useGetPermissions } from "helpers/useGetPermissions";
import { formatDateString } from "pages/homes/HomeDashboard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectNotificationItems,
  setNotificationItems,
} from "reducers/workflowNotifications";

export type WorkflowNotification = {
  workflowActionInstances__Id: number | null;
  workflowActionInstances__WorkflowInstancesID: number | null;
  workflowActionInstances__MessageText: string | null;
  workflowActionInstances__CompletionDate: string | null;
  workflowActionInstances__CompletedBy: string | null;
  sites__Id: number | null;
  sites__ClientID: number | null;
  sites__SitesName: string | null;
  projects__Id: number | null;
  projectTypes__Type: string | null;
  programmes__Name: string | null;
  bCommunication: boolean;
};

export const WorkflowNotificationItem = ({
  notification,
  openMenu,
  closeMenu,
  isDisabled,
}: {
  notification: WorkflowNotification;
  openMenu?: () => void;
  closeMenu?: () => void;
  isDisabled?: boolean;
}) => {
  const {
    workflowActionInstances__MessageText,
    sites__Id,
    sites__ClientID,
    sites__SitesName,
    projectTypes__Type,
    programmes__Name,
    projects__Id,
    workflowActionInstances__CompletedBy,
    workflowActionInstances__CompletionDate,
    bCommunication,
  } = notification;

  const homePermissions = useGetPermissions(homePermissionsRequested, "/home");

  const dispatch = useDispatch();
  const workflowNotifications = useSelector(selectNotificationItems);
  const viewNotificationEnabled =
    homePermissions.has("notifications-view") &&
    homePermissions.get("notifications-view");

  let parsedDate: string | null = workflowActionInstances__CompletionDate
    ? formatDateString(workflowActionInstances__CompletionDate)
    : null;

  if (parsedDate) {
    let tempParsedDate = parsedDate.split(":");

    if (Array.isArray(tempParsedDate)) {
      parsedDate = tempParsedDate.slice(0, -1).join(":");
    }
  }

  return (
    <div className="WorkFlowNotificationMenuItem">
      <div className="MenuRow FirstRow">
        {/* <div className="MenuRowLeft"></div>
        <div className="MenuRowRight"></div> */}
        <div className="SiteInfo">
          <span className="SiteID">{`Principle ID: ${sites__Id}`}</span>
          <span className="ClientID">{`Client ID: ${sites__ClientID ?? "-"}`}</span>
        </div>
        <span className="SiteName">{sites__SitesName}</span>
      </div>
      <div className="MenuRow">
        <h3>{workflowActionInstances__MessageText}</h3>
      </div>
      <div className="MenuRow LastRow" style={{ marginTop: "8px" }}>
        {bCommunication ? (
          <span className="DateTime">Read by {workflowActionInstances__CompletedBy} on {parsedDate ?? "-"}</span>
        ) : (
        <span className="DateTime">
          {` Date & time of completion: ${parsedDate ?? "-"}`}
          {/* {` ${workflowNotifications__CompletionDate}`} */}
        </span>
         )}
        {viewNotificationEnabled && (
          <a
            //href="#"
            onClick={() => {
              dispatch(setNotificationItems([notification]));
              return false;
            }}
            style={{ cursor: "pointer" }}
          >
            {" "}
            {`${bCommunication ? "View communication" : "View workflow"}`}
            
          </a>
        )}
      </div>
    </div>
  );
};
